import { Box, forwardRef, HTMLChakraProps, useMergeRefs } from '@chakra-ui/react';

import { useReverseScroll } from '@/hooks/useReverseScroll';

export const ReverseScrollBox = forwardRef<HTMLChakraProps<'div'>, 'div'>((props, ref) => {
  const { ref: reverseScrollRef } = useReverseScroll();

  const refs = useMergeRefs(ref, reverseScrollRef);

  return <Box ref={refs} {...props} />;
});
